const Subtract = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 22.062 22.062"
  >
    <path
      id="minimize_7699207"
      d="M11.031,22.062C1.947,22.062,0,20.115,0,11.031S1.947,0,11.031,0,22.062,1.947,22.062,11.031,20.115,22.062,11.031,22.062ZM7.354,10.112a.919.919,0,1,0,0,1.839h7.354a.919.919,0,1,0,0-1.839Z"
      transform="translate(0)"
      fill="inherit"
      fill-rule="evenodd"
    />
  </svg>
);

export default Subtract;
